import React from 'react';
import UnitBlockingListing from './listing';

// Thin wrapper: reuses the exact same filters/grid as Unit Block, just with
// mode="release" so the bulk action button/modal call the release endpoints.
const UnitReleaseListing = () => <UnitBlockingListing mode="release" />;

export default UnitReleaseListing;
